import React from 'react'
import PropTypes from 'prop-types'
import AccountListRow from './AccountListRow'
import { NavLink } from 'react-router-dom'

const AccountList = ({accounts}) => {
  let accountsRow = ""
  if(accounts.length < 1){
    accountsRow = <div className="gst-error">Sorry, it seems you have no accounts.<br/>You can register one <NavLink exact to="/register">here</NavLink></div>
  }

  return (
    <div className="gs-table-wrapper">
      <table className="table gs-table noStyle">
        <thead className="gst-header">
          <tr>
            <th className="gsth-cell hideMob">ID</th>
            <th className="gsth-cell">Account Name</th>
            <th className="gsth-cell hideMob">Email address</th>
            <th className="gsth-cell hideMob">Address</th>
            <th className="gsth-cell hideMob">Admin Name</th>
            <th className="gsth-cell hideMob">Main Contact</th>
            <th className="gsth-cell">Options</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map(account =>
            <AccountListRow key={account.id} account={account}/>
          )}
        </tbody>
      </table>
      {accountsRow}
    </div>
  );
};

AccountList.propTypes = {
  accounts: PropTypes.array.isRequired
};

export default AccountList;



// WEBPACK FOOTER //
// ./src/components/account/AccountList.js